module.exports = __webpack_public_path__ + "img/nodejs.85458a67.png";